import { Component, Input, OnInit } from '@angular/core';
import { RegistrationService } from 'src/app/services/registration.service';

@Component({
  selector: 'app-logo',
  templateUrl: './logo.component.html',
  styleUrls: ['./logo.component.css']
})
export class LogoComponent implements OnInit {

  @Input('color') color:string = "black"
  @Input('width') width:string = '110px'

  @Input()
  providerTitle!: string;

  constructor() { }

  ngOnInit(): void {
  }

}
